import { render, staticRenderFns } from "./Checkups.vue?vue&type=template&id=73ae4200&"
import script from "./Checkups.vue?vue&type=script&lang=js&"
export * from "./Checkups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports